<template>
	<div style="border: solid 8px #e5e5e5; height: 400px;">
		<div class="text-msg-wrapper">
	      <h5 style="color: #464646;">
	        <div v-if="isMaxAttemptReached" class="mb-3">You have used all your attempts. No attempt remaining.</div>
	        <div v-if="getProgress == 1">
	            You can continue learning this resource any time by clicking on it in the Table of Contents or by clicking “Resume”.<br><br>
	            <div v-if="getPerformance && !hideScoreForStudent" > Current Score : {{getPerformance}} % </div> 
	            <b-button @click="launch" variant="primary" size="lg" class="btn_lg" aria-label="Resume" style="background: rgb(25, 148, 22);">Resume</b-button>
	    
	        </div> 
	        <div v-if="getProgress == 2">
	            Great! You’re done with this learning resource. <br><br>
	            <div v-if="getPerformance && !hideScoreForStudent" > Current Score : {{getPerformance}} % </div> 

	            <b-button v-if="isMaxAttemptReached == false"  @click="launch" variant="primary" size="lg" class="btn_lg" aria-label="Learn Again" style="background: rgb(25, 148, 22);">Learn Again</b-button>

	        </div> 
	      </h5>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
  export default {
    name: 'scorm-done',
    data: () => {
      return {
        isMaxAttemptReached: false,
        scormResource : {title:'Test'},
        entityUuid:'',
        token:'',
        scormId:'',
        courseId:'',
        hideScoreForStudent:true
 
      }
    },
    created () {
      if (this.$route.query) {
        this.isMaxAttemptReached = (this.$route.query.max_attempt_reached === 'true')
        if(this.$route.query.assetId) {
          this.entityUuid = this.$route.query.assetId
          this.token = this.$route.query.token
          this.scormId = this.$route.query.scormId
          this.hideScoreForStudent = this.$route.query.hideScoreForStudent
          this.courseId = this.$route.query.courseId
          this.loadScormSummary()
        }
      }
    },
    methods: {
      ...mapActions([
        'loadScormDetail',
        'getScormLaunchURLWithToken'
      ]),

      loadScormSummary () {
        var entityInfo = {
        'entityUuid': this.entityUuid,
        'token': this.token
      }
        this.loadScormDetail(entityInfo).then(result => {
          this.scormResource = result
        })
      },
      launch () {
          this.getScormLaunchURLWithToken({'scormId': this.scormId,'token': this.token,'assetId' : this.entityUuid,'courseId': this.courseId}).then(result => { 
            window.open(result, '_self');
          })
          }
      },
      computed: {
        getProgress: function () {
          return this.scormResource.status
        },
        getPerformance: function () {
          return this.scormResource.performance
        }

      }
  }
</script>

<style scoped>
	.text-msg-wrapper {
		text-align: center;
    margin-top: 15%;
    margin-left: auto;
    margin-right: auto;
    max-width: 80%;
    width: 60%;
	}
</style>


// WEBPACK FOOTER //
// src/app/assessment/components/ScormDone.vue